<template>
  <div class="insurance">
    <div class="li-content">
      <div v-show="switchValue" class="border-style" @click="ShowTrafficStart">
        <mt-cell title="交强险起期" is-link>
          <span
            style="color: rgba(102, 102, 102, 1)"
          >{{ JQStartDate }} {{ JQStartHour }}时{{ JQStartMinute }}分</span>
        </mt-cell>
      </div>
      <div v-show="alter" class="border-style" @click="ShowBusinessStart">
        <mt-cell title="商业险起期" is-link>
          <span
            style="color: rgba(102, 102, 102, 1)"
          >{{ SYStartDate }} {{ SYStartHour }}时{{ SYStartMinute }}分</span>
        </mt-cell>
      </div>
    </div>
    <div class="li-content">
      <div class="border-styles">
        <span>车辆实际价值（元）</span>
        <input v-model="actualValue" style="background: #fff" type="text" disabled="disabled">
      </div>
      <div class="border-styles">
        <span>约定车辆价值（元）</span>
        <input v-model="agreeActualValue" type="text" placeholder="请输入" @input="changeAgree">
      </div>
    </div>
    <div class="li-content">
      <div class="border-style">
        <mt-cell class="title-weight" title="交强险">
          <mt-switch
            v-model="switchValue"
            @change="onChange($event)"
          />
        </mt-cell>
      </div>
      <div v-show="switchValue" class="border-style colors">
        <mt-cell title="保额">
          {{ JQAmount }}
        </mt-cell>
      </div>
      <div v-show="switchValue" class="border-style colors">
        <mt-cell title="保费">
          {{ plusPremium }}
        </mt-cell>
      </div>
    </div>
    <div v-show="switchValue" class="li-content">
      <div class="border-style">
        <mt-cell class="title-weight" title="车船税">
          {{ SumPayTax }}
        </mt-cell>
      </div>
      <div class="border-styles" @click="exhibition">
        <span>车船税</span>
        <p>{{ taxRelifFlagnae }}</p>
      </div>
      <div
        v-if="
          taxRelifInfo.hfCode !== '1' &&
            taxRelifInfo.hfCode !== '5' &&
            taxRelifInfo.hfCode !== '4'
        "
        class="border-styles"
      >
        <span><span class="start">*</span>减免税凭证号</span>
        <input v-model="taxRelifInfo.extendChar2" type="text" @blur="loses">
      </div>
      <div v-if="taxRelifInfo.hfCode === '4'" class="border-styles">
        <span><span class="start">*</span>完税凭证号</span>
        <input
          v-model="taxRelifInfo.paidFreeCertificate"
          type="text"
          @blur="loses"
        >
      </div>
      <div
        v-if="taxRelifInfo.hfCode === '4'"
        class="border-style"
        @click="choice"
      >
        <mt-cell title="完税凭证填发日期">
          <span>
            {{ taxRelifInfo.taxDocumentDate }}
            <img :src="imgUrlPriceTime" class="cell-img" alt>
          </span>
          <span slot="icon" style="padding-left: 0;color: #f00;">*</span>
          <span />
        </mt-cell>
      </div>
      <div
        v-if="taxRelifInfo.hfCode === '4'"
        class="border-style"
        @click="open"
      >
        <mt-cell title="开具完税凭证地区名称" is-link>
          <span style="color: rgba(102, 102, 102, 1)">{{
            taxPaidAreaCode
          }}</span>
          <span slot="icon" style="padding-left: 0;color: #f00;">*</span>
        </mt-cell>
      </div>
      <div
        v-if="taxRelifInfo.hfCode !== '5' && taxRelifInfo.hfCode !== '1'"
        class="border-styles"
      >
        <span>开具税务机关代码</span>
        <input v-model="taxRelifInfo.taxComCode" type="text" @blur="loses">
      </div>
      <div
        v-if="taxRelifInfo.hfCode !== '5' && taxRelifInfo.hfCode !== '1'"
        class="border-styles"
      >
        <span><span class="start">*</span>开具凭证税务机关名</span>
        <input v-model="taxRelifInfo.taxComName" type="text" @blur="loses">
      </div>
      <div v-if="taxRelifInfo.hfCode === '4'" class="border-styles">
        <span><span class="start">*</span>完税金额</span>
        <input v-model="taxRelifInfo.SumPayTax" type="text" @blur="loses">
      </div>
      <div v-if="isQD" class="border-styles">
        <span><span class="start">*</span>税务登记证号</span>
        <input v-model="taxRelifInfo.taxRegistryNumber" type="text" placeholder="请输入税务登记证号" @blur="loses">
      </div>
    </div>
    <div class="li-content">
      <div class="border-style">
        <mt-cell class="title-weight" title="商业险">
          <mt-switch v-model="alter" @change="onChanges($event)" />
        </mt-cell>
      </div>
      <div v-show="alter" class="border-style">
        <mt-cell title="保费">
          {{ SYpremium }}
        </mt-cell>
      </div>
      <!-- 车损险 -->
      <div v-show="alter">
        <div
          v-for="(item, index) in insurance"
          v-show="index < showMore"
          :key="index"
          class="boxstyle"
        >
          <div class="choose-area" @click.stop="Changes(index)">
            <div
              :id="item.kindCode === 'A1' ? 'choose-inner' : ''"
              class="choose-inner"
            >
              <div class="mint-cell-title">
                <van-icon
                  size="16"
                  :name="item.values ? 'checked' : 'circle'"
                  :color="item.values ? '#F29600' : '#D4D4D4'"
                  style="line-height: 30px"
                />
                {{ item.kindName }}
              </div>
              <div class="choose-inners" style="display: flex">
                <div class="top">
                  保额
                </div>
                <div
                  v-if="
                    item.kindCode !== 'A' &&
                      item.kindCode !== 'D4' &&
                      item.kindCode !== 'D3' &&
                      item.kindCode !== 'F' &&
                      item.kindCode !== 'Q4' &&
                      item.kindCode !== 'Z' &&
                      item.kindCode !== 'G'
                  "
                  class="bottoms"
                  @click.stop="onAmount(item, 1)"
                >
                  {{ item.amount.text }}
                  <div style="transform: rotate(90deg); display: inline-block">
                    <van-icon v-if="item.amount !== '-'" name="play" />
                  </div>
                </div>
                <div v-if="item.kindCode === 'A'" class="bottomtwo">
                  {{ amounts }} <span v-if="item.amount">元</span>
                </div>
                <div v-if="item.kindCode === 'D3'" class="choose-input">
                  <input
                    v-model="item.unitAmount.text"
                    placeholder="请输入"
                    @click.stop=""
                    @keyup="
                      clearNumPrice(
                        $event,
                        item.precision,
                        item.integerLength,
                        'insurance',
                        'unitAmount.text',
                        index
                      )
                    "
                    @blur="
                      clearNumPrice(
                        $event,
                        item.precision,
                        item.integerLength,
                        'insurance',
                        'unitAmount.text',
                        index
                      )
                    "
                    @change="D3Amount(index, item)"
                  >万元/座&nbsp;x&nbsp;1座
                </div>
                <div
                  v-if="item.kindCode === 'D4'"
                  class="choose-input"
                  style="display: flex"
                >
                  <input
                    v-model="item.unitAmount.text"
                    placeholder="请输入"
                    @click.stop=""
                    @keyup="
                      clearNumPrice(
                        $event,
                        item.precision,
                        item.integerLength,
                        'insurance',
                        'unitAmount.text',
                        index
                      )
                    "
                    @blur="
                      clearNumPrice(
                        $event,
                        item.precision,
                        item.integerLength,
                        'insurance',
                        'unitAmount.text',
                        index
                      )
                    "
                    @change="passengerAmount(index, item)"
                  >万元/座
                  <div>
                    <span>&nbsp;x&nbsp;{{ actulResult.seatCount - 1 }} 座</span>
                  </div>
                </div>
              </div>
              <div
                v-if="item.kindCode === 'A'"
                class="mianpei"
                style="display: flex"
              >
                <p class="textstyle">
                  选择免赔额
                </p>
                <div class="bottoms" @click.stop="onAmount(item, 1)">
                  {{ item.value.text }}
                  <div style="transform: rotate(90deg); display: inline-block">
                    <van-icon name="play" />
                  </div>
                </div>
              </div>
            </div>
            <div class="choose-inner1">
              <p>保费</p>
              <a>{{ item.premium }}</a>
            </div>
          </div>
          <div v-show="item.accessoryRiskshow">
            <p class="fontstyle">
              附加
            </p>
            <div
              v-for="(kind, k) in item.accessoryRisk"
              :key="k"
              @click.stop="riskChanges(index, k)"
            >
              <div v-if="kind.showRisk" class="choose-areas boxcolor">
                <div
                  :id="kind.kindCode === 'A1' ? 'choose-inner' : ''"
                  class="choose-inner"
                >
                  <div class="mint-cell-title">
                    <van-icon
                      size="16"
                      :name="kind.values ? 'checked' : 'circle'"
                      :color="kind.values ? '#F29600' : '#D4D4D4'"
                      style="line-height: 30px"
                    />
                    {{ kind.kindName }}
                  </div>
                  <div class="choose-inners" style="display: flex">
                    <div class="top">
                      {{ kind.excessText }}
                    </div>
                    <div
                      v-if="kind.layoutStyle === '1'"
                      class="bottoms"
                      @click.stop="onAmount(kind, 1)"
                    >
                      {{ kind.amount.text || kind.deductibleRate.text }}
                      <div
                        style="transform: rotate(90deg); display: inline-block"
                      >
                        <van-icon name="play" class="icon-color" />
                      </div>
                    </div>
                    <div v-if="kind.layoutStyle === '2'" class="choose-input">
                      <input
                        v-model="kind.amount"
                        class="colorwrite"
                        placeholder="请输入"
                        @click.stop=""
                        @keyup="
                          clearNumPrice(
                            $event,
                            kind.precision,
                            kind.integerLength,
                            'insurance',
                            'amount',
                            index,
                            k
                          )
                        "
                        @blur="
                          clearNumPrice(
                            $event,
                            kind.precision,
                            kind.integerLength,
                            'insurance',
                            'amount',
                            index,
                            k
                          )
                        "
                      >
                      <p>元</p>
                    </div>
                  </div>
                </div>
                <div class="choose-inner1">
                  <p>保费</p>
                  <a>{{ kind.premium }}</a>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="!item.accessoryRiskshow"
            class="expend"
            @click="changeAccessoryRisk(item, index)"
          >
            <p>展开</p>
            <div class="flexconter">
              <img :src="dropDown" alt="">
            </div>
          </div>
          <div
            v-if="item.accessoryRiskshow"
            class="expend"
            @click="changeAccessoryRisk(item, index)"
          >
            <p>收起</p>
            <div class="flexconter">
              <img :src="dropUp" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="li-content">
      <div class="border-style">
        <mt-cell class="title-weight" title="更多服务">
          <mt-switch v-model="switchServe" />
        </mt-cell>
      </div>
      <div v-if="switchServe" class="boxstyle" style="padding-bottom: 0.1rem">
        <div
          v-for="(kind, k) in moreServeData"
          :key="k"
          class="choose-areas boxcolor"
          @click.stop="moreRiskChange(k)"
        >
          <div
            :id="kind.kindCode === 'A1' ? 'choose-inner' : ''"
            class="choose-inner"
          >
            <div class="mint-cell-title">
              <van-icon
                size="14"
                :name="kind.values ? 'checked' : 'circle'"
                :color="kind.values ? '#F29600' : '#D4D4D4'"
                style="line-height: 30px"
              />
              {{ kind.kindName }}
            </div>
            <div class="choose-inners" style="display: flex">
              <div class="top">
                {{ kind.excessText }}
              </div>
              <div
                v-if="kind.layoutStyle === '1'"
                class="bottoms"
                @click.stop="onAmount(kind, 2)"
              >
                {{ kind.serviceTimes.text }}
                <div style="transform: rotate(90deg); display: inline-block">
                  <van-icon name="play" />
                </div>
              </div>
              <div v-if="kind.layoutStyle === '2'" class="choose-input">
                <input
                  v-model="kind.serviceTimes"
                  class="colorwrite"
                  placeholder="请输入"
                  @click.stop=""
                  @keyup="
                    clearNumPrice(
                      $event,
                      kind.precision,
                      kind.integerLength,
                      'moreServeData',
                      'serviceTimes',
                      k
                    )
                  "
                  @blur="
                    clearNumPrice(
                      $event,
                      kind.precision,
                      kind.integerLength,
                      'moreServeData',
                      'serviceTimes',
                      k
                    )
                  "
                >次
              </div>
            </div>
          </div>
          <div class="choose-inner1">
            <p>保费</p>
            <a>{{ kind.premium }}</a>
          </div>
        </div>
      </div>
    </div>
    <!-- 全面保障 -->
    <div class="guarantee">
      <img class="guaranteeBackgroIMG" :src="guaranteeBackgroIMG" alt="">
      <img class="guaranteeTitle" :src="guaranteeTitle" alt="">
      <img
        class="showDetail"
        :src="showDetail"
        alt=""
        @click="showCarXDetail"
      >
      <img
        class="selectInsuranceTypes"
        :src="selectInsuranceTypes"
        alt=""
        @click="showProduct"
      >
    </div>
    <!-- 车+X -->
    <baozhang
      ref="baozhang"
      :x-bottom="xBottom"
      :carx-detail="carxDetail"
      :start-time="startTime"
      @price="changePrice"
      @address="changeAdress"
    />
    <div v-show="alter" class="li-content">
      <div class="border-style">
        <mt-cell class="title-weight" title="商业险折扣信息" />
      </div>
      <div class="inner-content">
        <div class="inner-style">
          <div>
            <span>无赔款优待系数:</span>
            <span>{{ ciProfitDetailData.nonclaimAdjuct }}</span>
          </div>
          <div>
            <span>无赔优系数级别:</span>
            <span>{{ ciProfitDetailData.claimAdjustLevel }}</span>
          </div>
        </div>
        <div class="inner-style">
          <div>
            <span>交通违法系数:</span>
            <span>{{ ciProfitDetailData.safeAdjust }}</span>
          </div>
        </div>
        <div class="inner-style">
          <div>
            <span>连续承保年数:</span>
            <span>{{ ciProfitDetailData.insureYears }}</span>
          </div>
          <div>
            <span>连续承保期间出险次数:</span>
            <span>{{ ciProfitDetailData.claimTimes }}</span>
          </div>
        </div>
        <van-radio-group v-model="quoteRadio" @change="radioChange">
          <div v-if="!publics" class="inner-style">
            <van-radio name="1" shape="square" icon-size="14px" label-disabled checked-color="#592581">
              <div :class="quoteRadio === '1' ? 'quoteActive' : ''">
                <span>建议自主定价系数:</span>
                <span>{{ underwritingProfitRate }}</span>
              </div>
            </van-radio>
          </div>
          <div v-if="!publics" class="inner-style">
            <van-radio name="2" shape="square" icon-size="14px" label-disabled checked-color="#592581">
              <div :class="quoteRadio === '2' ? 'quoteActive' : ''">
                <span>自主定价系数:</span>
                <input
                  v-model="underwriting.profitRate"
                  class="input-style"
                  type="text"
                  placeholder="请输入"
                  :disabled="quoteRadio === '1'"
                >
                <span>{{ underwriting.profitRates }}</span>
              </div>
            </van-radio>
          </div>
        </van-radio-group>
      </div>
    </div>
    <div v-show="basePart.isDjqShow" class="li-content">
      <div class="border-styles" style="margin-bottom: 0.15rem">
        <span>是否真单交</span>
        <input
          v-model="basePart.isDjqText"
          type="text"
          style="background: #fff"
          placeholder="报价后可见"
          disabled="disabled"
        >
      </div>
    </div>
    <div class="foot">
      <div v-if="switchValue && alter" class="foot-flex">
        <p>交强险定价评分：<span>{{ revPredScoreAdjust }}</span></p>
        <p>交强险预期赔付率：<span v-if="lrReComAdjust">{{ `${lrReComAdjust}%` }}</span></p>
      </div>
      <div v-if="alter" class="foot-flex">
        <p>商业险定价评分：<span>{{ pricingScore }}</span></p>
        <p>商业险预期赔付率：<span v-if="lrRecom">{{ `${lrRecom}%` }}</span></p>
      </div>
      <div class="foot-flex">
        <p>标费含NCD预期赔付率：<span>{{ ncdBpremELR }}</span></p>
      </div>
      <div class="foot-flex">
        <div>
          <p>商业折扣险：<span>{{ discount }}</span></p>
          <p>总保费：<span>{{ sumPremium }}</span></p>
        </div>
        <div class="plat-info" @click="onAlready">
          <p>平台信息</p>
        </div>
      </div>
      <div v-show="goNextBtn" class="next-step">
        <div v-if="!publics" class="img_area">
          <div @click="share">
            <img :src="shareImg" alt="">
          </div>
        </div>
        <button class="save-btn" @click="baoJia">
          报价
        </button>
        <button @click="goNext">
          下一步
        </button>
      </div>
    </div>
    <van-popup v-model="popupVisible" position="bottom" close-on-click-overlay>
      <van-picker
        :columns="columns"
        show-toolbar
        @confirm="onConfirm"
        @cancel="popupVisible = false"
      />
    </van-popup>
    <!-- 投保份数 -->
    <van-popup
      v-model="popupTBVisible"
      position="bottom"
      close-on-click-overlay
    >
      <van-picker
        :columns="TBcolumns"
        show-toolbar
        @confirm="onTouBconfirm"
        @cancel="popupTBVisible = false"
      />
    </van-popup>
    <!-- 个人重疾保额 -->
    <van-popup
      v-model="popupBEVisible"
      position="bottom"
      close-on-click-overlay
    >
      <van-picker
        :columns="BEcolumns"
        show-toolbar
        @confirm="onBaoEconfirm"
        @cancel="popupBEVisible = false"
      />
    </van-popup>
    <!-- 有无社保选择器 -->
    <van-popup
      v-model="popupSBVisible"
      position="bottom"
      close-on-click-overlay
    >
      <van-picker
        :columns="SBcolumns"
        show-toolbar
        @confirm="onSheBconfirm"
        @cancel="popupSBVisible = false"
      />
    </van-popup>
    <!-- 是否续保选择器 -->
    <van-popup
      v-model="popupXBVisible"
      position="bottom"
      close-on-click-overlay
    >
      <van-picker
        :columns="XBcolumns"
        show-toolbar
        @confirm="onXuBconfirm"
        @cancel="popupXBVisible = false"
      />
    </van-popup>
    <!-- 保险条款、投保须知及声明 -->
    <van-popup
      v-model="insuranceClauseVisible"
      position="bottom"
      :style="{ height: '60%', fontSize: '0.14rem' }"
      v-html="insuranceClauseContent"
    />
    <!-- 不能续保的提示弹框 -->
    <van-popup
      v-model="isXuBao"
      style="border-radius: 8px"
      :close-on-click-overlay="false"
    >
      <div class="TracBackTicket">
        <div class="box">
          <div class="title">
            没有找到您的上年度保单，可能原因：
          </div>
          <div class="context">
            <div>① 上年度保单不在可续保时间范围内</div>
            <div>② 保单号/证件号码输入有误</div>
            <div>③ 上年度投保产品与当前产品不符</div>
          </div>
          <div class="agreeBtn" @click="agree">
            确定
          </div>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="popupVisibles" position="bottom" close-on-click-overlay>
      <van-picker
        :columns="columns"
        show-toolbar
        @confirm="onConfirms"
        @cancel="popupVisibles = false"
      />
    </van-popup>
    <van-popup
      v-model="popupTimeVisible"
      position="bottom"
      close-on-click-overlay
    >
      <van-datetime-picker
        type="datetime"
        :value="currentDate"
        :min-date="minDate"
        @confirm="sureHour"
        @cancel="popupTimeVisible = false"
      />
    </van-popup>
    <van-popup
      v-model="popupDateVisible"
      position="bottom"
      close-on-click-overlay
    >
      <van-datetime-picker
        type="datetime"
        :value="currentDate"
        :min-date="minTime"
        :max-date="currentDate"
        @confirm="sureHour"
        @cancel="popupDateVisible = false"
      />
    </van-popup>
    <van-popup v-model="whether" position="bottom" close-on-click-overlay>
      <van-picker
        :columns="columns"
        show-toolbar
        @confirm="affirm"
        @cancel="whether = false"
      />
    </van-popup>
    <!-- 提示上年保单起期与止期 -->
    <div v-if="decide || decideCI" class="exteriors">
      <div class="exterior">
        <div class="exterior-top">
          <h2>报价成功</h2>
          <ul>
            <li v-if="lastStartDate && decide">
              <p>商业险上年保单起期:</p>
              <span>{{ lastStartDate }}</span>
            </li>
            <li v-if="lastStartDateCI && decideCI">
              <p>交强险上年保单起期:</p>
              <span>{{ lastStartDateCI }}</span>
            </li>
            <li v-if="lastEndDate && decide">
              <p>商业险上年保单止期:</p>
              <span>{{ lastEndDate }}</span>
            </li>
            <li v-if="lastEndDateCI && decideCI">
              <p>交强险上年保单止期:</p>
              <span>{{ lastEndDateCI }}</span>
            </li>
          </ul>
        </div>
        <div class="exterior-bottom" @click="close">
          确认
        </div>
      </div>
    </div>
    <div v-show="showConfirm || showConfirmCI" class="exteriors">
      <div class="exterior">
        <div class="exterior-top">
          <h2>报价成功</h2>
          <p class="exterior-text">
            是否将“保险起期”自动衔接“上年保单止期”?
          </p>
          <ul>
            <li v-if="lastStartDate && showConfirm">
              <p>商业险上年保单起期：</p><span>{{ lastStartDate }}</span>
            </li>
            <li v-if="lastStartDateCI && showConfirmCI">
              <p>交强险上年保单起期：</p><span>{{ lastStartDateCI }}</span>
            </li>
            <li v-if="lastEndDate && showConfirm">
              <p>商业险上年保单止期：</p><span>{{ lastEndDate }}</span>
            </li>
            <li v-if="lastEndDateCI && showConfirmCI">
              <p>交强险上年保险止期：</p><span>{{ lastEndDateCI }}</span>
            </li>
          </ul>
        </div>
        <div class="exterior-bottom confirm-btns">
          <span class="cancel-btn" @click="close">不用了</span>
          <span class="confirm-btn" @click="onConfirmToJoinDate">好的</span>
        </div>
      </div>
    </div>
    <!-- 车辆类型编码-->
    <van-popup v-model="carModel" class="model-pop" round position="bottom" lock-scroll>
      <div class="blank">
        <div class="model-title">
          选择车辆类型编码
        </div>
      </div>
      <div v-for="(item, i) in carModelList" :key="i" class="model-content" @click="choiceType(i)">
        <div class="model-left">
          <img :src="item.active ? modelSrc1 : modelSrc0" alt="">
        </div>
        <div class="model-right">
          <div class="model-cell">
            <div class="model-label">
              行业车行编码
            </div>
            <div class="model-value">
              {{ item.vehicleCode }}
            </div>
          </div>
          <div class="model-cell">
            <div class="model-label">
              车型识别编码
            </div>
            <div class="model-value">
              {{ item.vehicleMangline }}
            </div>
          </div>
          <div class="model-cell">
            <div class="model-label">
              品牌名称
            </div>
            <div class="model-value">
              {{ item.brandName }}
            </div>
          </div>
          <div class="model-cell">
            <div class="model-label">
              车系名称
            </div>
            <div class="model-value">
              {{ item.familyName }}
            </div>
          </div>
          <div class="model-cell">
            <div class="model-label">
              车款名称
            </div>
            <div class="model-value">
              {{ item.modelName }}
            </div>
          </div>
          <div class="model-cell">
            <div class="model-label">
              公告型号
            </div>
            <div class="model-value">
              {{ item.publicModel }}
            </div>
          </div>
          <div class="model-cell">
            <div class="model-label">
              车损险纯风险保费
            </div>
            <div class="model-value">
              {{ item.pureRiskPremium }}
            </div>
          </div>
        </div>
      </div>
      <div class="box">
        <div class="model-confirm">
          <button class="model-btn" @click="newChoiceModel">
            确定
          </button>
        </div>
      </div>
    </van-popup>
    <div v-if="isFixed" class="fixed">
      <div class="innerbox">
        <div class="content">
          <ul>
            <li v-if="switchValue">
              <div
                v-if="
                  alter
                    ? basePart.renewalFlagCI === '1'
                    : basePart.renewalFlag === '1'
                "
              >
                <h2>请输入交强险查询校验码</h2>
                <div
                  v-if="alter && basePart.renewalFlagCI === '1'"
                  class="class"
                >
                  <img
                    :src="'data:image/jpeg;base64,' + basePart.questionCI"
                    alt=""
                  >
                  <input v-model="answerCI" type="text">
                </div>
                <div v-else class="class">
                  <img
                    :src="'data:image/jpeg;base64,' + basePart.question"
                    alt=""
                  >
                  <input v-model="answerCI" type="text">
                </div>
              </div>
            </li>
            <li v-if="alter">
              <div v-if="basePart.renewalFlag === '1'">
                <h2>请输入商业险查询校验码</h2>
                <div class="class">
                  <img
                    :src="'data:image/jpeg;base64,' + basePart.question"
                    alt=""
                  >
                  <input v-model="answer" type="text">
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="bottom">
          <span @click="shut">取消</span>
          <span @click="submitYzm">提交</span>
        </div>
      </div>
    </div>
    <van-popup v-model="demonstrate" position="bottom" close-on-click-overlay>
      <van-picker
        :columns="columns"
        show-toolbar
        @confirm="onConfirm4($event)"
        @cancel="demonstrate = false"
      />
    </van-popup>
    <van-dialog
      v-model="IsTaxRegistryNumber"
      title="请输入税务登记证号"
      confirm-button-text="完成"
      confirm-button-color="#5E2589"
      :before-close="onBeforeClose"
      @confirm="taxNumConfirm"
    >
      <div class="tax-num">
        <input v-model="taxRelifInfo.taxRegistryNumber" type="text" placeholder="请输入税务登记证号">
        <p>必填</p>
      </div>
    </van-dialog>
    <div v-show="isPop" class="popbox" @click="isPop = false">
      <img :src="shouzhi" alt="" class="shouzhi">
      <div class="ptext">
        <p>点击右上角</p>
        <p>将报价单分享给微信好友</p>
      </div>
    </div>
    <div v-show="isSuccess" class="success">
      <div class="innerbox">
        <van-icon name="cross" color="#9B9B9B" @click="isSuccess = false" />
        <img :src="successImg" alt="">
        <p>{{ successTip }}</p>
        <div class="success-info-content">
          <div class="success-info" style="text-align: right" />
          <div class="success-info" style="text-align: left" />
          <button @click="isSuccess = false">
            确认
          </button>
        </div>
      </div>
    </div>
    <div v-if="frame" class="ErrorTips">
      <div class="Bottoming">
        <div class="Bottoming-top" v-html="analysis">
          <div />
          {{ analysis }}
        </div>
        <div class="Bottoming-buttom" @click="determination">
          确定
        </div>
      </div>
    </div>
    <PlatformInformation
      v-show="isPopupVisible"
      @close="closePopup"
    />
    <Loading :switchs="switchs" />
    <div v-if="isClose">
      <productList
        :start-time="startTime"
        :end-time="endTime"
        @product="getShowClose"
      />
    </div>
  </div>
</template>
<script>
import { Toast, Icon, Dialog } from 'vant'
import riskDate from '@/utils/riskDate.js'
import { numMulti, SolveThrough } from '@/utils/checkFormat.js'
import api from '@/api/api.js'
import Loading from '@/components/Loadings/Loading'
import PlatformInformation from '../PlatformInformation/PlatformInformation'
import configure from '@/api/configure.js'
import productList from '../components/productList'
import baozhang from '../components/baozhang'
import { taxationTypes } from '@/utils/const.js'
import { quteMixin } from './Mixin/mixin'
import { newQuoteMixin } from './Mixin/quoteMixin'
import { checkMixin } from './Mixin/checkMixin'

export default {
  components: {
    'van-icon': Icon,
    Loading: Loading,
    PlatformInformation,
    productList,
    baozhang,
    [Dialog.Component.name]: Dialog.Component
  },
  mixins: [quteMixin, newQuoteMixin, checkMixin],
  data() {
    return {
      quoteRadio: '1',
      addressFlag: {
        jiaCai: true,
        ranQi: true
      },
      startTime: '',
      endTime: '',
      isClose: false, // 是否展示产品下拉框
      insuranceList: [],
      agreeChecked: false,
      isGuangDong: false, // 驾乘“广东专属方案”，投保份数显现
      isXuBao: false,
      carxDetail: true,
      xBottom: '', // 眼睛关闭 底部样式类名
      showDetail: api.imgAllUrl + '/openDetail.png',
      selectInsuranceTypes: api.imgAllUrl + '/selectInsuranceTypes.png',
      trashCan: api.imgAllUrl + '/trashCan.png',
      guaranteeBackgroIMG: api.imgAllUrl + '/guaranteeBackgro.png',
      guaranteeTitle: api.imgAllUrl + '/guaranteeTitle.png',
      JSRpremium: '报价后可见', // 驾驶人意外险 保费
      JSRStartDate: '', // 驾驶人意外险 时间
      JSREndDate: '', // 驾驶人意外险 时间
      JSRStartHour: '00',
      JSREndHour: '24',
      JSRStartMinute: '00',
      JSREndMinute: '00',
      JSRSchemeData: [], // 驾驶人意外险可选择方案
      // 驾驶人意外险方案 (入参所需要)
      JSRScheme: {
        text: '', // 对应方案的的名字
        code: '', // 对应方案的编码
        sumAmount: '0', // 保额
        sumPremium: '0', // 保费
        commiFee: '0', // 手续费
        riskCode: '' // 险种对应的编码
      },
      dropUp: api.imgAllUrl + '/drop_up.png',
      dropDown: api.imgAllUrl + '/drop_down.png',
      taxPaidAreaCode: '', // 展示的完税地区
      whether: false, // 完税地区选择器开个
      frame: false,
      analysis: '',
      isPopupVisible: false,
      answerCI: '',
      answer: '',
      basePart: {
        isDjq: '', // 是否真单交---前提是只有交强险
        isDjqShow: false,
        isDjqText: ''
      },
      already: false, // 平台信息是否显示
      adds: 0,
      switchs: false,
      price: false, // 是否已报价
      // Coefficient: false, // 渠道系数是否有值
      // 无赔优系数
      PayFor: {
        profitCode: 'C20',
        profitRate: ''
      },
      // 交通系数调整系数
      Traffic: {
        profitCode: 'C33',
        profitRate: ''
      },
      lastEndDate: '',
      lastEndDateCI: '',
      lastStartDate: '',
      lastStartDateCI: '',
      decide: false, // 商业险是否本期起期大于上年止期
      decideCI: false, // 交强险是否本期起起大于上年止期
      showConfirm: false, // 是否显示商业险自动带入弹框
      showConfirmCI: false, // 是否显示交强险自动带入弹框
      joinSy: false, // 是否进行商业险自动带入
      joinJq: false, // 是否进行交强险自动带入
      carModel: false, // 车辆类型编码弹框开关
      modelSrc1: api.imgAllUrl + '/modelSrc1.png',
      modelSrc0: api.imgAllUrl + '/modelSrc0.png',
      parameters: null, // 报价传参暂存
      carModelList: [], // 车型列表
      carModelIndex: 0,
      actualValue: '', // 车辆实际价值
      agreeActualValue: '', // 约定车辆价值
      totals: '0', // 不报案车驾意保费报价后的总保费
      SYhandlingFee: '报价后可见', // 商业险手续费
      JQhandlingFee: '报价后可见', // 交强险手续费
      // 驾乘私家意外险方案 (入参所需要)
      scheme: {
        text: '',
        code: '',
        sumAmount: '0',
        sumPremium: '0',
        commiFee: '0',
        riskCode: ''
      },
      popupVisibles: false, // 险种方案选择
      schemeData: [], // 车驾意选择方案
      SumPayTax: '报价后可见', // 车船税价格
      taxRelifFlagnae: '正常缴税',
      demonstrate: false, // 车船税选择方案开关
      taxRelifInfo: {
        extendChar2: '', // 减免税凭证号
        taxComName: '', // 开具凭证的税务机关名称
        hfCode: '1', // 车船税code
        paidFreeCertificate: '', // 完税凭证号
        taxDocumentDate: '', // 完税凭证填发日期
        SumPayTax: '', // 完税金额
        taxPaidAreaCode: '', // 开具完税凭证地区名称
        taxComCode: '',
        taxRegistryNumber: '' // 税务登记证号，仅青岛
      },
      showMore: 5, // 更多
      showMoreContent: '更多',
      isSuccess: false,
      successImg: api.imgAllUrl + '/sales410807.jpg',
      successTip: '报价成功',
      isFixed: false,
      isJq: true,
      isSy: true,
      jqPhoto: '',
      syPhoto: '',
      jqanswerCI: '',
      syanswer: '',
      imgUrlPriceTime: api.imgAllUrl + '/sales390709.png',
      chooseDown: api.imgAllUrl + '/sales380709.png',
      shareImg: api.imgAllUrlZSB + '/share-20190911.png',
      switchValue: true, // 交强险开关
      alter: true, // 商业险开关
      calculateFlag: '0', // 是否关联单标识
      JQStartDate: '',
      JQEndDate: '',
      JQStartHour: '00',
      JQStartMinute: '00',
      JQEndHour: '24',
      JQEndMinute: '00',
      SYStartDate: '',
      SYEndDate: '',
      SYStartHour: '00',
      SYStartMinute: '00',
      SYEndMinute: '00',
      SYEndHour: '24',
      minDate: '',
      currentDate: '',
      mDate: new Date(2000, 1, 1),
      huahenAmount: '',
      SJAmount: {
        text: '1',
        code: '10000'
      },
      SJUnitAmount: {
        text: '1',
        code: '10000'
      },
      CKAmount: {
        text: '1',
        code: '10000'
      },
      CKUnitAmount: {
        text: '1',
        code: '10000'
      },
      // 交强险数据
      JQinsurance: {
        kindName: '机动车交通事故强制责任险',
        kindCode: 'BZ',
        amount: '200000', // 保额
        discount: '', // 折扣系数
        premium: '报价后可见', // 实交保费
        calculateFlag: 'Y11Y00', // 是否计入保额
        flag: '', // 标志字段（主险；附加险；）
        rate: '', // 费率
        basePremium: '', // 基础保费
        benchMarkPremium: '', // 基准保费
        riskCode: '0590',
        values: false,
        value: ''
      },
      sanZheB: {
        kindName: '机动车第三者责任保险法定节假日限额翻倍险',
        kindCode: 'B2',
        amount: '500000', // 保额
        discount: '', // 折扣系数
        premium: '', // 实交保费
        calculateFlag: 'N22N00', // 是否计入保额
        flag: '', // 标志字段（主险；附加险；）
        rate: '', // 费率
        basePremium: '', // 基础保费
        benchMarkPremium: '', // 基准保费
        riskCode: '050A',
        value: '0',
        select: false
      },
      // 司机险
      driver: {
        kindName: '司机险',
        kindCode: 'D3',
        show: true,
        amountShow: true,
        amount: '10000', // 保额
        discount: '', // 折扣系数
        premium: '报价后可见', // 实交保费
        calculateFlag: 'Y21Y00', // 是否计入保额
        flag: '', // 标志字段（主险；附加险；）
        rate: '', // 费率
        basePremium: '', // 基础保费
        benchMarkPremium: '', // 基准保费
        riskCode: '050A',
        unitAmount: '10000', // 每座保额
        quantity: '1', // 座位数
        values: true,
        value: ''
      },
      // 乘客险
      passenger: {
        kindName: '乘客险',
        kindCode: 'D4',
        show: true,
        amountShow: true,
        amount: '', // 保额
        discount: '', // 折扣系数
        premium: '报价后可见', // 实交保费
        calculateFlag: 'Y21Y00', // 是否计入保额
        flag: '', // 标志字段（主险；附加险；）
        rate: '', // 费率
        basePremium: '', // 基础保费
        benchMarkPremium: '', // 基准保费
        unitAmount: '', // 每座保额
        quantity: '', // 座位数
        riskCode: '050A',
        values: false,
        value: ''
      },
      // 渠道系数
      channel: {
        profitCode: 'C32',
        profitRate: '1',
        profitRates: '',
        maxProfitRate: '',
        minProfitRate: '',
        jYChanrel: '报价后可见'
      },
      ciProfitDetailData: {
        nonclaimAdjuct: '报价后可见', // 无赔款优待系数
        claimAdjustLevel: '报价后可见', // 无赔优系数级别
        safeAdjust: '报价后可见', // 交通违法系数
        insureYears: '报价后可见', // 连续承保年数
        claimTimes: '报价后可见' // 连续承保期间出险次数
      },
      underwritingProfitRate: '报价后可见', // 建议自主定价系数
      // 核保系数
      underwriting: {
        profitCode: 'C31',
        profitRate: '',
        profitRates: '',
        maxProfitRate: '',
        minProfitRate: ''
      },
      columns: [],
      XBcolumns: [
        {
          text: '否',
          code: 0
        },
        {
          text: '是',
          code: 1
        }
      ],
      SBcolumns: [
        {
          text: '无',
          code: 0
        },
        {
          text: '有',
          code: 1
        }
      ],
      TBcolumns: [
        {
          text: '1',
          code: 0
        },
        {
          text: '2',
          code: 1
        },
        {
          text: '3',
          code: 2
        },
        {
          text: '4',
          code: 3
        },
        {
          text: '5',
          code: 4
        }
      ],
      BEcolumns: [
        {
          text: '10万重度疾病',
          code: 0,
          sum: '100000',
          extra: '0'
        },
        {
          text: '20万重度疾病',
          code: 1,
          sum: '200000',
          extra: '0'
        },
        {
          text: '30万重度疾病',
          code: 2,
          sum: '300000',
          extra: '0'
        }
      ],
      sumPayTax: '报价后可见', // 车船税
      SYpremium: '报价后可见', // 商业险保费
      JQpremium: '报价后可见', // 交强险保费
      JQAmount: '20万', // 交强险保额
      plusPremium: '报价后可见', // 交强加上车船税
      sumPremium: '报价后可见', // 总保费
      discount: '报价后可见', // 商业险折扣
      pricingScore: '', // 商业险定价评分
      revPredScoreAdjust: '', // 交强险定价评分
      lrRecom: '', // 商业险预期赔付率
      lrReComAdjust: '', // 交强险预测评分
      ncdBpremELR: '报价后可见',
      seatCount: '', // 车辆座位数
      seatCountVal: '', // 实际购买座位数
      popupVisible: false, // 单项选择器
      popupSBVisible: false, // 有无社保选择器
      popupXBVisible: false, // 是否续保选择器
      popupTBVisible: false, // 投保份数选择器
      popupBEVisible: false, // 个人重疾保额选择器
      insuranceClauseVisible: false, // 保险条款、投保须知及声明显示器
      insuranceClauseContent: '', // 保险条款、投保须知及声明内容
      popupTimeVisible: false, // 时间选择器
      popupDateVisible: false, // 完税日期
      minTime: new Date(1900, 0, 1),
      hadPrice: false, // 是否已报价
      uwRel: '', // 核保建议系数
      status: '',
      actulResult: '',
      isCertify: '', // 是否认证
      amounts: '', // 实际价格
      shareLogo: api.imgAllUrl + '/wxLogo20210616.png',
      isPop: false,
      shouzhi: api.imgAllUrl + '/sales410723.png',
      illegalInfoList: [], // 违法信息列表(平台信息)
      hisClaimList: [], // 历史理赔列表（历史理赔列表）
      publics: true,
      goNextBtn: true,
      originHeight: '',
      region: [], // 完税地区信息
      switchServe: true, // 更多服务开关
      dropDownKey: 0, // 下拉框数据选择
      IsTaxRegistryNumber: false,
      OldTaxRegistryNumber: ''
    }
  },
  computed: {
    productXInfoDTOList() {
      return this.$store.state.productXInfoDTOList
    }
  },
  watch: {
    SYStartDate() {
      this.changeTime()
    },
    SYStartHour() {
      this.changeTime()
    },
    SYStartMinute() {
      this.changeTime()
    },
    SYEndDate() {
      this.changeTime()
    },
    SYEndHour() {
      this.changeTime()
    },
    SYEndMinute() {
      this.changeTime()
    },
    alter: function(newVal, oldVal) {
      this.switchServe = newVal
    },
    calculateFlag: function(newVal, oldVal) {
      if (newVal === '0' || newVal === '1') {
        this.realValueJQ(this.SYStartDate)
      } else if (newVal === '2') {
        this.realValueJQ(this.JQStartDate)
      }
    },
    // 监听司机险
    'SJUnitAmount.text': function(newVal, oldVal) {
      this.calculate()
    },
    // 监听乘客险
    'CKUnitAmount.text': function(newVal, oldVal) {
      this.passengerAmount()
    },
    'driver.values': function(newVal, oldVal) {
      if (newVal === false) {
        this.driver.premium = '报价后可见'
      }
    },
    'passenger.values': function(newVal, oldVal) {
      if (newVal === false) {
        this.passenger.premium = '报价后可见'
      }
    },
    adds(value) {
      this.switchs = value > 0
    }
  },
  mounted() {
    if (this.$route.params.params && this.$route.params.params.rtnCode === '0000') {
      const resProvData = this.$route.params.params
      if (resProvData.vehicleInfo) {
        this.$store.commit('setVehicleInfo', resProvData.vehicleInfo)
      }
      if (resProvData.carOwnerInfo) {
        this.$store.commit('setCarOwnerInfo', resProvData.carOwnerInfo)
      }
      if (resProvData.insuredList) {
        this.$store.commit('setInsuredList', resProvData.insuredList)
      }
      if (resProvData.baseInfo) {
        this.$store.commit('setBaseInfo', resProvData.baseInfo)
      }
      if (resProvData.itemKindList) {
        this.$store.commit('setItemkindList', resProvData.itemKindList)
      }
      this.$store.commit('setEntrance', 1)
      this.$store.commit('setLabel', true)
      this.$store.commit('setOrderId', resProvData.orderId)
      this.$store.commit('setTotal', resProvData)
      this.$store.commit('setProposalAreaCode', resProvData.proposalAreaCode)
    } else if (this.$store.state.params && this.$store.state.params.rtnCode === '0000') {
      const resProvData = this.$store.state.params
      if (resProvData.vehicleInfo) {
        this.$store.commit('setVehicleInfo', resProvData.vehicleInfo)
      }
      if (resProvData.carOwnerInfo) {
        this.$store.commit('setCarOwnerInfo', resProvData.carOwnerInfo)
      }
      if (resProvData.insuredList) {
        this.$store.commit('setInsuredList', resProvData.insuredList)
      }
      if (resProvData.baseInfo) {
        this.$store.commit('setBaseInfo', resProvData.baseInfo)
      }
      if (resProvData.itemKindList) {
        this.$store.commit('setItemkindList', resProvData.itemKindList)
      }
      this.$store.commit('setEntrance', 1)
      this.$store.commit('setLabel', true)
      this.$store.commit('setOrderId', resProvData.orderId)
      this.$store.commit('setTotal', resProvData)
      this.$store.commit('setProposalAreaCode', resProvData.proposalAreaCode)
    }
    this.publics = localStorage.getItem('setUserString') !== 'B'
    this.getDetail()
    const carry = {
      codeLevel: 2,
      codeType: 'AdminDivisionCode'
    }
    this.adds += 1
    this.$http.post(api.getCodeType, carry).then(res => {
      if (res.data.rtnCode === '0000') {
        this.region = res.data.result
      }
      this.adds = this.adds - 1
    }).catch(error => {
      this.adds = this.adds - 1
      console.log(error)
    })
  },
  activated() {
    this.checkQD()
    const UserInfo = JSON.parse(localStorage.getItem('setPersonUserInfo'))
    let agentCode
    if (UserInfo && localStorage.getItem('setChannelCode') === configure.ZKICATMChannelCode) {
      agentCode = UserInfo.remoteBindAgentCode ? UserInfo.remoteBindAgentCode : ''
      if (agentCode && (UserInfo.accountType === '6' || UserInfo.accountType === '7')) {
        // 远程出单点、远程出单点员工
        this.$http.post(api.findAgentDtailByCode, { agentCode: agentCode }).then(res => {
          if (res.data.rtnCode === '0000') {
            const businessNature = res.data.agentType
            this.queryProducts(agentCode, businessNature)
          }
        })
      } else {
        // 业务员
        this.queryProducts(agentCode, '0')
      }
    } else if (localStorage.getItem('setChannelCode') === configure.DPOWXPAChannelCode) {
      // c端客户
      this.queryProducts(agentCode, '8')
    }
    this.originHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight || 0
    const u = navigator.userAgent
    const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 // g
    if (isAndroid) {
      // 这个是安卓操作系统
      window.addEventListener('resize', this.resizeFn)
    }
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
    this.$store.commit('setStep', '3')
    this.$store.commit('setShow', true)
    this.actulResult = this.$store.state.vehicleInfos // 车辆信息
    this.recognizeeIn = this.$store.state.recognizeeIn // 被保人信息
    this.insurance.forEach(item => {
      item.accessoryRisk.forEach(kind => {
        if (kind.kindCode === 'B2') {
          kind.showRisk = this.actulResult.useNatureCode === '85'
        }
        if (kind.kindCode === 'D2') {
          kind.showRisk = this.actulResult.useNatureCode === '9D'
        }
      })
    })
    this.seatCount = Number(this.actulResult.seatCount) - 1 // 乘客座位数等于总座位数-1
    this.seatCountVal = this.seatCount // 就等于实际购买座位数
    this.passenger.quantity = this.seatCountVal
    this.CKAmount.text = Number(this.CKUnitAmount.text) * Number(this.passenger.quantity)
    this.passenger.amount = Number(this.CKAmount.text) * 10000 + ''
    this.passenger.unitAmount = Number(this.CKUnitAmount.text) * 10000 + ''
    this.getDate()
    this.realValueJQ(this.SYStartDate)
    this.insurance.forEach((value, index) => {
      if (value.kindCode === 'D4') {
        this.insurance[index].seatCount = this.actulResult.seatCount - 1
        if (value.unitAmount.text !== '0' && value.unitAmount.text !== '') {
          this.insurance[index].amount = numMulti(numMulti(Number(value.unitAmount.text), Number(this.actulResult.seatCount - 1)), 10000) + ''
        } else {
          this.insurance[index].amount = '0'
        }
      }
    })
    const obj = {
      enrollDate: this.actulResult.certificateDate,
      startDate: this.SYStartDate
    }
    this.getTicket()
    this.adds += 1
    this.$http.post(api.getChanAndUwRatio, obj).then(res => {
      if (res.data.rtnCode === '0000') {
        this.underwriting.profitRates = res.data.uwMin + '~' + res.data.uwMax
        this.underwriting.maxProfitRate = res.data.uwMax
        this.underwriting.minProfitRate = parseFloat(res.data.uwMin)
      } else {
        this.underwriting.profitRates = '0.65~1.35'
        this.underwriting.maxProfitRate = '1.35'
        this.underwriting.minProfitRate = '0.65'
      }
      this.adds = this.adds - 1
    }).catch(error => {
      this.adds = this.adds - 1
      console.log(error)
    })
    // 保险起期规则：若投了商业险，等于商业险起期；若投了交强险，等于交强险起期；两者都投，等于商业险；不存在两者都不投
    if (this.alter) {
      // 商业险起期
      this.changeTime()
    } else {
      if (this.switchValue) {
        // 交强险起期
        this.startTime = `${this.JQStartDate} ${this.JQStartHour}时${this.JQStartMinute}分`
        this.endTime = `${this.JQEndDate} ${this.JQEndHour}时${this.JQEndMinute}分`
      } else {
        this.$toast('请选择险种信息')
      }
    }
  },
  deactivated() {
    Toast.clear()
    window.removeEventListener('resize', this.resizeFn)
    this.goNextBtn = true
  },
  methods: {
    changeAgree() {
      this.amounts = this.agreeActualValue
      this.agreeActualValue ? this.insurance[0].amount = this.agreeActualValue : this.insurance[0].amount = this.actualValue
      this.price = false
    },
    choiceType(codeIndex) {
      for (const keys in this.carModelList) {
        this.carModelList[keys].active = false
      }
      this.carModelList[codeIndex].active = true
      this.carModelIndex = codeIndex
    },
    onConfirmToJoinDate() {
      this.decide = false
      this.decideCI = false
      this.showConfirm = false
      this.showConfirmCI = false
      this.price = false
      this.changeStartDateToLastEndDate()
    },
    changeStartDateToLastEndDate() {
      this.price = false
      //  商业险
      if (this.lastEndDate && this.joinSy) {
        const lDateNum = new Date(this.lastEndDate.replace(/-/g, '/')).getTime()
        if (!Number.isNaN(lDateNum)) {
          const nowTimeStr = new Date(this.lastEndDate.replace(/-/g, '/')).getTime()
          this.status = 'BusinessStart'
          this.sureHour(nowTimeStr)
        }
        this.joinSy = false
      }
      if (this.lastEndDateCI && this.joinJq) {
        const lDateNum = new Date(this.lastEndDateCI.replace(/-/g, '/')).getTime()
        if (!Number.isNaN(lDateNum)) {
          const nowTimeStr = new Date(this.lastEndDateCI.replace(/-/g, '/')).getTime()
          this.status = 'TrafficStart'
          this.sureHour(nowTimeStr)
        }
        this.joinJq = false
      }
    },
    getShowClose(data) {
      this.isClose = data
    },
    changePrice(price) {
      this.price = price
    },
    changeAdress(param) {
      if (param.productCode === 'ZKICATM_0314') {
        this.addressFlag.jiaCai = param.value
      } else if (param.productCode === 'WX0317') {
        this.addressFlag.ranQi = param.value
      }
    },
    showProduct() {
      this.isClose = true
      this.$store.commit('set_productXInfoDTOList', this.$refs.baozhang.validata())
      this.price = false
    },
    // "全面保障" 点击右侧眼睛，判断车+X是否显示详情
    showCarXDetail() {
      this.carxDetail = !this.carxDetail
      if (!this.carxDetail) {
        this.xBottom = 'border-style-xBottom'
        this.showDetail = api.imgAllUrl + '/closeDetail.png'
      } else {
        this.xBottom = ''
        this.showDetail = api.imgAllUrl + '/openDetail.png'
      }
    },
    // 车+X保期跟随商业险变动
    changeTime() {
      this.startTime = `${this.SYStartDate} ${this.SYStartHour}时${this.SYStartMinute}分`
      this.endTime = `${this.SYEndDate} ${this.SYEndHour}时${this.SYEndMinute}分`
    },
    determination() {
      this.frame = false
      SolveThrough(false)
    },
    resizeFn() {
      const resizeHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight || 0
      this.originHeight - 0 > resizeHeight - 0 ? this.goNextBtn = false : this.goNextBtn = true
    },
    setSYDefaultData() {
      this.SYStartDate = this.$store.state.baseInfo.startDate
      this.SYEndDate = this.$store.state.baseInfo.endDate
      this.SYStartHour = this.$store.state.baseInfo.startHour
      this.SYEndHour = this.$store.state.baseInfo.endHour
      this.SYStartMinute = this.$store.state.baseInfo.startMinute
      this.SYEndMinute = this.$store.state.baseInfo.endMinute
    },
    setJQDefaultData() {
      this.JQStartDate = this.$store.state.baseInfo.startDateCI
      this.JQEndDate = this.$store.state.baseInfo.endDateCI
      this.JQStartHour = this.$store.state.baseInfo.startHourCI
      this.JQEndHour = this.$store.state.baseInfo.endHourCI
      this.JQStartMinute = this.$store.state.baseInfo.startMinuteCI
      this.JQEndMinute = this.$store.state.baseInfo.endMinuteCI
    },
    // 返回riskData数组中对应的数据
    filterRiskArrData(kindCode, amount, defaultObj) {
      let objData = defaultObj
      riskDate.riskArrData.forEach(resData => {
        if (kindCode === resData.kindCode) {
          resData.riskTextArr.forEach(amountData => {
            if (amount === amountData.code) {
              objData = amountData
            }
          })
        }
      })
      return objData
    },
    evaluation(item) {
      this.scheme.text = item.text
      this.scheme.code = item.code
      this.scheme.sumAmount = item.sumAmount
      this.scheme.sumPremium = item.sumPremium
      this.scheme.commiFee = item.commiFee
      this.scheme.riskCode = item.riskCode
    },
    close() {
      // 上年保单时间提示关闭
      this.decide = false
      this.decideCI = false
      this.showConfirm = false
      this.showConfirmCI = false
      this.price = true
    },
    open() {
      this.whether = true
      const column = []
      this.region.forEach((value, index) => {
        const obj = {}
        obj.code = value.codeCode
        obj.text = value.codecname
        column.push(obj)
      })
      this.columns = column
    },
    affirm(value) {
      this.whether = false
      this.taxPaidAreaCode = value.text
      this.taxRelifInfo.taxPaidAreaCode = value.code
    },
    // 删除对应险种的函数
    deleteInsurance(type) {
      this.insuranceList.forEach(item => {
        if (item.productCode === type) {
          item.flag = false
        }
      })
      this.$store.commit('set_productXInfoDTOList', this.insuranceList)
    },
    exhibition() {
      // 车船税选择方案
      this.demonstrate = true
      this.columns = taxationTypes
    },
    showMoreFn() {
      if (this.showMore === 5) {
        this.showMore = this.insurance.length
        this.showMoreContent = '收起'
      } else {
        this.showMore = 5
        this.showMoreContent = '更多'
      }
    },
    // 交强险起期
    ShowTrafficStart() {
      this.popupTimeVisible = true
      this.status = 'TrafficStart'
    },
    // 商业险起期
    ShowBusinessStart() {
      this.popupTimeVisible = true
      this.status = 'BusinessStart'
    },
    // 投保份数选择器 确定函数
    onTouBconfirm(value) {
      this.insuranceList.forEach(item => {
        if (item.productCode === this.status) {
          item.insuranceNumber.text = this.TBcolumns[value.code].text
          item.insuranceNumber.code = this.TBcolumns[value.code].code
        }
      })
      this.popupTBVisible = false
    },
    // 个人重疾保额选择器 确定函数
    onBaoEconfirm(value) {
      this.insuranceList[6].sumInsured.text = this.BEcolumns[value.code].text
      this.insuranceList[6].sumInsured.code = this.BEcolumns[value.code].code
      this.insuranceList[6].sumInsured.sum = this.BEcolumns[value.code].sum
      this.insuranceList[6].sumInsured.extra = this.BEcolumns[value.code].extra
      this.popupBEVisible = false
    },
    // 有无社保选择器 确定函数
    onSheBconfirm(value) {
      this.insuranceList.forEach(item => {
        if (item.productCode === this.status) {
          item.conditionParam.isShebaoText = this.SBcolumns[value.code].text
          item.conditionParam.isShebaoCode = this.SBcolumns[value.code].code
        }
      })
      this.popupSBVisible = false
    },
    // 不能续保的提示弹框
    agree() {
      this.isXuBao = false
    },
    // 监听交强险
    onChange(e) {
      this.$store.commit('setAlter', '3')
      this.price = false
      if (this.switchValue === false && this.alter === false) {
        this.$toast('请选择险种信息')
      } else { // 至少选择一个
        if (this.switchValue === true && this.alter === true) {
          this.calculateFlag = '0'
        }
        if (this.switchValue === false && this.alter === true) {
          this.calculateFlag = '1'
        }
        if (this.switchValue === true && this.alter === false) {
          this.calculateFlag = '2'
        }
      }
    },
    // 监听商业险
    onChanges(e) {
      this.$store.commit('setAlter', '3')
      this.price = false
      if (this.switchValue === false && this.alter === false) {
        this.$toast('请选择险种信息')
      } else {
        if (this.switchValue === true && this.alter === true) {
          this.calculateFlag = '0'
        }
        if (this.switchValue === false && this.alter === true) {
          this.calculateFlag = '1'
        }
        if (this.switchValue === true && this.alter === false) {
          this.calculateFlag = '2'
        }
      }
      console.log(this.alter)
    },
    // 计算司机险保额
    calculate() {
      this.SJAmount.text = this.SJUnitAmount.text
      if (this.SJUnitAmount.text !== '0' && this.SJUnitAmount.text !== '') {
        this.SJAmount.code = Math.round(Number(this.SJUnitAmount.text) * 10000) + ''
        this.SJUnitAmount.code = Math.round(Number(this.SJUnitAmount.text) * 10000) + ''
        this.driver.amount = this.driver.unitAmount = this.SJUnitAmount.code
      }
    },
    // 车船税失去焦点
    loses() {
      this.price = false
      this.isChange = true
      this.$store.commit('setAlter', '3')
    },
    changeAccessoryRisk(item, index) {
      item.accessoryRiskshow = !item.accessoryRiskshow
    },
    // 选择保额
    onAmount(val, key) {
      this.dropDownKey = key
      this.switch = val.values
      this.index = val.kindCode
      this.popupVisibles = true
      riskDate.riskArrData.forEach(item => {
        if (val.kindCode === item.kindCode) {
          this.columns = item.riskTextArr
        }
      })
      for (const i in this.columns) {
        if (val.amount.code === this.columns[i].code) {
          this.columns.defaultIndex = Number(i)
        }
      }
    },
    shut() {
      this.isFixed = false
      SolveThrough(true)
    },
    // 完税选择时间
    choice() {
      const date = this.$moment(new Date().getTime()).add(1, 'd')
      const year = new Date(date).getFullYear()
      const month = this.filtration(new Date(date).getMonth())
      const daa = this.filtration(new Date(date).getDate())
      this.currentDate = new Date(year, month, daa)
      this.popupDateVisible = true
      this.status = 'choice'
    },
    onAlready() {
      // 点击平台信息
      this.isPopupVisible = true
      const data = {
        illegalInfoList: this.illegalInfoList,
        hisClaimList: this.hisClaimList
      }
      localStorage.setItem('Popdate', JSON.stringify(data))
    },
    closePopup() {
      this.isPopupVisible = false
      document.documentElement.style.overflow = 'scroll'
    },
    D3Amount(i, item) {
      // 司机险输入保费监听
      this.price = false
      this.$store.commit('setAlter', '3')
      if (item.unitAmount.text !== '0' && item.unitAmount.text !== '') {
        this.insurance[i].amount = Math.round(Number(item.unitAmount.text) * 10000) + ''
        this.insurance[i].unitAmount.code = Math.round(Number(item.unitAmount.text) * 10000) + ''
      } else {
        this.insurance[i].amount = '0'
        this.insurance[i].unitAmount.code = '0'
        this.insurance[i].unitAmount.text = '0'
      }
    },
    passengerAmount(i, item) {
      this.price = false
      this.$store.commit('setAlter', '3')
      this.insurance[i].unitAmount.text = item.unitAmount.text
      this.insurance[i].unitAmount.code = numMulti(Number(item.unitAmount.text), 10000) + ''
      this.insurance[i].seatCount = this.actulResult.seatCount - 1
      if (item.unitAmount.text !== '0' && item.unitAmount.text !== '') {
        this.insurance[i].amount = numMulti(numMulti(Number(item.unitAmount.text), Number(this.actulResult.seatCount - 1)), 10000) + ''
      } else {
        this.insurance[i].amount = '0'
        this.insurance[i].unitAmount.code = '0'
        this.insurance[i].unitAmount.text = '0'
      }
    },
    riskChanges(index, k) {
      this.price = false
      this.$store.commit('setAlter', '3')
      if (this.insurance[index].values) {
        this.insurance[index].accessoryRisk[k].values = !this.insurance[index].accessoryRisk[k].values
        if (this.insurance[index].accessoryRisk[k].values && this.insurance[index].accessoryRisk[k].kindCode === 'B2') {
          this.insurance[index].accessoryRisk[k].amount = this.insurance[index].amount.code
        }
      } else {
        Toast('请先选择对应主险')
      }
    },
    moreRiskChange(k) {
      this.price = false
      this.$store.commit('setAlter', '3')
      let indexNum = 0
      for (let i = 0; i < this.insurance.length; i++) {
        if (!this.insurance[i].values) {
          indexNum++
        }
      }
      if (this.alter) {
        if (indexNum === this.insurance.length) {
          Toast('请先选择任一主险')
        } else {
          this.moreServeData[k].values = !this.moreServeData[k].values
        }
      } else {
        Toast('请先选择任一主险')
      }
    },
    // 核保系数校验
    checkInputNum(num, maxNum, minNum) {
      const add = /^\d{0,8}(\.\d{1,5})?$/
      if (!add.test(num) || (num < minNum || num > maxNum)) {
        return false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "./insurance.scss";
</style>



// WEBPACK FOOTER //
// src/pages/car/newQuote/index.vue